import {
    omit as _omit,
} from '@lodash';
import AbstractMapper from '@core/utils/mappers/AbstractMapper';
import { ISuperOfferDto } from '@core/mappers/offer/dtos/ISuperOfferDto';
import SuperOffer from '@core/models/offer/SuperOffer';
import EventMapper from '@core/mappers/offer/EventMapper';

const eventMapper: EventMapper = new EventMapper();

export default class SuperOfferMapper extends AbstractMapper<ISuperOfferDto, SuperOffer> {
    createTargetObject(dto: ISuperOfferDto, key: number): SuperOffer {
        const superOffer = new SuperOffer();
        Object.entries(dto).forEach(([key, value]) => {
            superOffer[key] = eventMapper.map(value, true);
        });
        return superOffer;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/mappers/offer/SuperOfferMapper.ts